// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import StoreRequestRmaPageState from "@store/Framework/Store/Store/Pages/RequestRma/RequestRmaPageState";
import { Draft } from "immer";

const initialState: StoreRequestRmaPageState = {
    warehouse: "",
};

const actions = {
    "Store/Pages/RequestRma/SetReturnWarehouse": (
        draft: Draft<StoreRequestRmaPageState>,
        action: { warehouse?: string },
    ) => {
        draft.warehouse = action.warehouse;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type StoreRequestRmaPageActions = Parameters<typeof reducer>[1];
export default reducer;
